<template>
  <div class="classification">
    <van-tree-select
      height="55vw"
      :items="items"
      :main-active-index.sync="active"
      @click-nav="ActiveClick(items[active].id)"
    >
      <template #content>
        <div class="tabTitle">
          <ul>
            <li
              class="comprehensive"
              :class="
                isClick == 1 ? 'active' : isClick == 2 ? 'inActiveRight' : ''
              "
              @click="allGoods()"
            >
              <p>综合</p>
              <!-- <div class="upDown">
                <van-icon name="arrow-up" />
                <van-icon name="arrow-down" />
              </div> -->
            </li>
            <li
              class="salesVolume"
              :class="isClick == 2 ? 'active' : ''"
              @click="salesVolumeFn()"
            >
              <p>销量</p>
              <div class="upDown">
                <van-icon
                  :size="isClick == 2 && !salesVolumeFlag ? 18 : ''"
                  name="arrow-up"
                />
                <van-icon
                  :size="isClick == 2 && salesVolumeFlag ? 18 : ''"
                  name="arrow-down"
                />
              </div>
            </li>
            <li
              class="price"
              :class="
                isClick == 3 ? 'active' : isClick == 2 ? 'inActiveLeft' : ''
              "
              @click="priceFn()"
            >
              <p>价格</p>
              <div class="upDown">
                <van-icon
                  :size="isClick == 3 && !priceFlag ? 18 : ''"
                  name="arrow-up"
                />
                <van-icon
                  :size="isClick == 3 && priceFlag ? 18 : ''"
                  name="arrow-down"
                />
              </div>
            </li>
          </ul>
        </div>
        <!-- 全部商品 -->
        <ul class="classificationProduct">
          <li
            v-for="commodity in commodityList"
            :key="commodity.id"
            @click="
              $router.push({ name: '商品详情', params: { id: commodity.id } })
            "
          >
            <div class="classificationProduct_img">
              <img :src="commodity.pic" alt="" />
            </div>
            <div class="classificationProduct_content">
              <p class="title">{{ commodity.desc }}</p>
              <div class="classificationProduct_content_bottom">
                <div class="classificationProduct_content_left">
                  ￥<span style="font-size: 0.18rem; font-weight: Bold">{{
                    parseInt(commodity.price)
                  }}</span>
                  <span style="font-size: 0.14rem">{{
                    commodity.price.substring(commodity.price.indexOf("."))
                  }}</span>
                </div>
                <div class="classificationProduct_content_right">
                  <img
                    src="../../assets/img/icon_shopping_basket@2x.png"
                    alt=""
                  />
                  <span>{{
                    commodity.buys > 1000
                      ? commodity.buys > 10000
                        ? parseInt(commodity.buys / 10000) + "w+"
                        : parseInt(commodity.buys / 1000) + "k+"
                      : commodity.buys
                  }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </template>
    </van-tree-select>
  </div>
</template>

<script>
import Title from "../../components/Title";
import { getClassificationList, getCommodityList } from "../../api/home";
export default {
  components: {
    Title,
  },
  data() {
    return {
      itemList: [],
      active: 0,
      isClick: 1,
      items: [{ id: 0, text: "全部商品" }],
      goodsList: {},
      commodityList: [], // 全部列表
      firstPurchase: [], // 初选列表
      repurchaseList: [], // 复选列表
      salesVolumeFlag: false,
      priceFlag: false,
      type_id: "0",
      order: "0",
    };
  },
  created() {
    this.intFn();
  },
  methods: {
    intFn() {
      getClassificationList()
        .then((res) => {
          this.itemList = res.data.backdata.shop_type;
          for (let i = 0; i < this.itemList.length; i++) {
            this.items.push({
              id: this.itemList[i].id,
              text: this.itemList[i].title,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.getGoodsFn();
    },
    getGoodsFn(val) {
      const loading = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      getCommodityList({ type_id: this.type_id, order: this.order })
        .then((res) => {
          this.commodityList = res.data.backdata.lists;
          loading.clear();
        })
        .catch((error) => {
          loading.clear();
        });
    },
    allGoods() {
      this.isClick = 1;
      this.salesVolumeFlag = false;
      this.priceFlag = false;
      this.order = "0";
      // this.type_id = "0";
      this.getGoodsFn();
    },
    salesVolumeFn() {
      this.isClick = 2;
      this.salesVolumeFlag = !this.salesVolumeFlag;
      this.priceFlag = false;
      if (this.salesVolumeFlag) {
        this.order = "4";
        this.getGoodsFn();
      } else {
        this.order = "3";
        this.getGoodsFn();
      }
    },
    priceFn() {
      this.isClick = 3;
      this.priceFlag = !this.priceFlag;
      this.salesVolumeFlag = false;
      if (this.priceFlag) {
        this.order = "2";
        this.getGoodsFn();
      } else {
        this.order = "1";
        this.getGoodsFn();
      }
    },
    ActiveClick(val) {
      this.type_id = val;
      this.getGoodsFn();
    },
  },
};
</script>

<style lang='scss'>
.classification {
  height: 100%;
  background: #f3f1f4;
  .tabTitle {
    padding: 0.79rem 0.15rem 0.13rem 0.08rem;
    position: fixed;
    background-color: #f3f1f4;
    ul {
      display: flex;
      width: 2.62rem;
      height: 0.27rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 0.12rem;
      overflow: hidden;
      color: #333333;
      li {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        border: 1px solid #35353d;
        // 综合
        &.comprehensive {
          border-radius: 0.15rem 0 0 0.15rem;
        }
        // 销量
        &.salesVolume {
          overflow: hidden;
          border-right: none;
          border-left: none;
        }
        // 价格
        &.price {
          border-radius: 0 0.15rem 0.15rem 0;
        }
        .upDown {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 0.028rem;
          .van-icon {
            &:nth-child(1) {
              transform: translateY(0.035rem) scale(0.6);
            }

            &:nth-child(2) {
              transform: translateY(-0.035rem) scale(0.6);
            }

            font-weight: 900;
            color: #35353d;
          }
        }
        &.active {
          background: linear-gradient(0deg, #dfb981 0%, hsl(37, 68%, 82%) 100%);
          border: 1px solid transparent;
          border-image: linear-gradient(
            0deg,
            #dfb981 0%,
            hsl(37, 68%, 82%) 100%
          );
          height: 0.27rem;
          color: #93683d;
          .van-icon {
            color: #93683d;
          }
        }
      }
      .inActiveRight {
        border-right: none;
      }
      .inActiveLeft {
        border-left: none;
      }
    }
  }
  .van-tree-select__content {
    background: #f3f1f4;
    .classificationProduct {
      width: 2.77rem;
      display: flex;
      flex-wrap: wrap;
      margin-left: 0.08rem;
      margin-top: 1.18rem;
      margin-bottom: 0.55rem;
      li {
        width: 1.28rem;
        background: #fafafa;
        margin-bottom: 0.06rem;
        margin-right: 0.06rem;
        border-radius: 0.08rem;
        overflow: hidden;
        .classificationProduct_img {
          img {
            width: 1.28rem;
            height: 1.28rem;
          }
        }
        .classificationProduct_content {
          width: 1.28rem;
          background: #ffffff;
          border-radius: 0rem 0rem 0.08rem 0.08rem;
          .title {
            font-size: 0.13rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            margin: 0.09rem 0.14rem 0.1rem 0.1rem;
          }
          .classificationProduct_content_bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.1rem 0.07rem 0.1rem;
            p {
              width: 1.04rem;
              font-size: 0.13rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
            .classificationProduct_content_left {
              font-size: 0.14rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #93683d;
            }
            .classificationProduct_content_right {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.12rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              img {
                width: 0.12rem;
                height: 0.12rem;
              }
            }
          }
        }
      }
    }
  }
  .van-tree-select {
    height: 100% !important;

    .van-tree-select__nav {
      position: fixed;
      margin-top: 0.68rem;
      background: #f3f1f4;
      width: 0.9rem;
      -webkit-box-flex: none;
      -webkit-flex: none;
      flex: none;

      .van-sidebar-item {
        width: 0.9rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.12rem;

        color: #333333;
        margin-bottom: 0.01rem;
        text-align: center;
        background: #ffffff;
        padding: 0rem;
      }

      .van-sidebar-item--select::before {
        display: none;
      }

      .van-sidebar-item--select {
        font-size: 0.14rem;

        font-weight: bold;
        color: #333333;
        background: #f3f1f4;
      }
    }

    .van-tree-select__content {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      flex: 1;
      margin-left: 0.9rem;
    }
  }
}
</style>
